import React from "react";

import {
  Card,
  CardBody,
  Grid,
  GridItem,
  Hero,
  PageSection,
  Skeleton,
  Stack,
  StackItem
} from "@patternfly/react-core";


const EducationDirectionPageSkeleton = () => {
  return (
    <div
      aria-busy="true"
      aria-label="Pobieranie danych kierunku"
    >
      <Stack hasGutter>
        <StackItem>
          <Hero
            isGlass
            bodyWidth="100%"
            bodyMaxWidth="100%"
          >
            <PageSection isWidthLimited>
              <Grid hasGutter>
                <GridItem
                  span={12}
                  lg={7}
                >
                  <Stack hasGutter>
                    <StackItem>
                      <Skeleton
                        width="8rem"
                        height="1.5rem"
                      />
                    </StackItem>

                    <StackItem>
                      <Skeleton
                        width="75%"
                        fontSize="4xl"
                        screenreaderText={
                          "Pobieranie danych kierunku"
                        }
                      />
                    </StackItem>

                    <StackItem>
                      <Stack hasGutter>
                        <Skeleton width="100%" />
                        <Skeleton width="92%" />
                        <Skeleton width="70%" />
                      </Stack>
                    </StackItem>

                    <StackItem>
                      <Grid hasGutter>
                        {[
                          "audience",
                          "duration",
                          "profession-number"
                        ].map((item) => (
                          <GridItem
                            key={item}
                            span={12}
                            sm={4}
                          >
                            <Stack hasGutter>
                              <StackItem>
                                <Skeleton
                                  width="5rem"
                                  height="0.75rem"
                                />
                              </StackItem>

                              <StackItem>
                                <Skeleton
                                  width="85%"
                                  height="1.25rem"
                                />
                              </StackItem>
                            </Stack>
                          </GridItem>
                        ))}
                      </Grid>
                    </StackItem>
                  </Stack>
                </GridItem>
              </Grid>
            </PageSection>
          </Hero>
        </StackItem>

        <StackItem isFilled />

        <StackItem>
          <PageSection isWidthLimited>
            <Stack hasGutter>
              <StackItem>
                <Grid>
                  <GridItem
                    span={12}
                    md={8}
                    mdOffset={2}
                  >
                    <Stack hasGutter>
                      <StackItem>
                        <Skeleton
                          width="45%"
                          fontSize="2xl"
                        />
                      </StackItem>

                      <StackItem>
                        <Skeleton width="100%" />
                      </StackItem>

                      <StackItem>
                        <Skeleton width="80%" />
                      </StackItem>
                    </Stack>
                  </GridItem>
                </Grid>
              </StackItem>

              <StackItem>
                <Grid hasGutter>
                  {[1, 2].map((item) => (
                    <GridItem
                      key={item}
                      span={12}
                      md={6}
                    >
                      <Card isFullHeight>
                        <CardBody>
                          <Stack hasGutter>
                            <StackItem>
                              <Skeleton
                                width="7rem"
                                height="2rem"
                              />
                            </StackItem>

                            <StackItem>
                              <Skeleton width="100%" />
                            </StackItem>

                            <StackItem>
                              <Skeleton width="85%" />
                            </StackItem>
                          </Stack>
                        </CardBody>
                      </Card>
                    </GridItem>
                  ))}
                </Grid>
              </StackItem>
            </Stack>
          </PageSection>
        </StackItem>
      </Stack>
    </div>
  );
};


export default EducationDirectionPageSkeleton;